import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { UI_EVENT_TYPE } from '@atlaskit/analytics-gas-types';
import { createAndFireNavigationEvent, SWITCHER_ITEM_SUBJECT } from '../../common/utils/analytics';
import { FormattedMessage } from 'react-intl-next';
var ItemLink = function ItemLink(_ref) {
  var label = _ref.label,
    href = _ref.href,
    testId = _ref.testId,
    onClick = _ref.onClick,
    ariaLabel = _ref.ariaLabel;
  var buttonProps = {
    appearance: 'link',
    href: href,
    className: 'section-link',
    target: '_blank',
    rel: 'noopener noreferrer',
    iconAfter: /*#__PURE__*/React.createElement(ShortcutIcon, {
      LEGACY_size: "small",
      color: "currentColor",
      label: ""
    }),
    onClick: onClick ? function (e, a) {
      return onClick(e, a);
    } : undefined,
    testId: testId
  };
  if (ariaLabel) {
    return /*#__PURE__*/React.createElement(FormattedMessage, ariaLabel, function (placeholder) {
      return /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
        "aria-label": String(placeholder)
      }), label);
    });
  }
  return /*#__PURE__*/React.createElement(Button, buttonProps, label);
};
export default withAnalyticsEvents({
  onClick: createAndFireNavigationEvent({
    eventType: UI_EVENT_TYPE,
    action: 'clicked',
    actionSubject: SWITCHER_ITEM_SUBJECT
  })
})(ItemLink);